import { render, staticRenderFns } from "./FormAlunoEdicao.vue?vue&type=template&id=57d91bfb"
import script from "./FormAlunoEdicao.vue?vue&type=script&lang=js"
export * from "./FormAlunoEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports